// assets/morak-protection-gallery.js
(function () {
  const DEBOUNCE_MS = 120;
  const VIDEO_THUMBNAIL_URL =
    "https://cdn.shopify.com/s/files/1/0664/8309/3585/files/Cases_Fundas_Iphone_Samsung_Morak_Dise_o_Premium.png?v=1785514405";
  let lastActiveNativeId = null;

  // --- Helpers ---
  function norm(s) {
    return String(s || "").trim().toLowerCase().replace(/\s+/g, " ");
  }

  function sanitizeUrl(u) {
    if (!u) return "";
    // Si es objeto (video), lo pasamos tal cual
    if (typeof u === "object") return u;
    let url = String(u).trim();
    url = url.replace(/\/files\/files\//g, "/files/");
    url = url.replace(/(cdn\/shop\/files)\/files\//g, "$1/");
    return url;
  }

  function getConfig(root = document) {
    const el = root.querySelector("script[data-morak-protection-config]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "{}");
    } catch {
      return null;
    }
  }

  function mapProtectionToTypeCode(label) {
    const t = norm(label);

    // 1.5m (Slim Guard)
    if (t.includes("1.5m")) return "S";

    // 5m
    if (t.includes("5m")) return "T";

    // 3m (siempre viene con blanco, negro o crystal)
    if (t.includes("3m")) {
      if (t.includes("negro")) return "N";
      if (t.includes("blanco")) return "B";
      if (t.includes("crystal")) return "C";
    }

    return null;
  }


  function getProtectionLabel(scope = document) {
    const texts = [];

    // selects
    scope.querySelectorAll("select").forEach((sel) => {
      const opt = sel.options?.[sel.selectedIndex];
      if (opt?.textContent) texts.push(opt.textContent.trim());
    });

    // radios
    scope.querySelectorAll('input[type="radio"]:checked').forEach((r) => {
      const lab = r.id ? scope.querySelector(`label[for="${CSS.escape(r.id)}"]`) : null;
      texts.push(((lab && lab.textContent) || r.value || "").trim());
    });

    const clean = texts.filter(Boolean);

    const candidates = clean.filter((x) => {
      const n = norm(x);
      return (
        n.includes("protección") ||
        n.includes("proteccion") ||
        n.includes("1.5m") ||
        n.includes("3m") ||
        n.includes("5m")
      );
    });

    if (!candidates.length) return "";

    // prioridad: 1.5m > 3m > 5m > "proteccion"
    const pick =
      candidates.find(x => norm(x).includes("1.5m")) ||
      candidates.find(x => norm(x).includes("3m"))   ||
      candidates.find(x => norm(x).includes("5m"))   ||
      candidates.find(x => {
        const n = norm(x);
        return n.includes("protección") || n.includes("proteccion");
      }) ||
      "";

    return pick;


  }

  function removeGeneric(mediaGallery) {
    mediaGallery.querySelectorAll('[data-morak-generic="true"]').forEach((n) => n.remove());
  }

  // Evita el "flash" de ver primero las miniaturas nativas del producto y luego que
  // cambien a las complementarias al elegir un Tipo de Case distinto: ocultamos la
  // tira de miniaturas/dots al instante del cambio, y la mostramos de nuevo (con
  // transición suave) una vez terminada la reconstrucción.
  function preHideThumbnails(mediaGallery) {
    mediaGallery.querySelectorAll(".slideshow-controls__thumbnails, .slideshow-controls__dots").forEach((el) => {
      el.style.transition = "opacity 160ms ease";
      el.style.opacity = "0";
    });
  }

  function revealThumbnails(mediaGallery) {
    mediaGallery.querySelectorAll(".slideshow-controls__thumbnails, .slideshow-controls__dots").forEach((el) => {
      el.style.transition = "opacity 160ms ease";
      el.style.opacity = "1";
    });
  }

  function setImgUrlDeep(rootEl, url) {
    rootEl.querySelectorAll("img").forEach((img) => {
      img.setAttribute("src", url);
      img.removeAttribute("srcset");
      img.removeAttribute("data-src");
      img.removeAttribute("data-srcset");
    });

    rootEl.querySelectorAll("source").forEach((s) => {
      s.removeAttribute("srcset");
      s.removeAttribute("data-srcset");
    });
  }

  // --- Slideshow (carousel) ---
  
  function appendGenericToSlideshow(mediaGallery, items, baseIndex) {
    const slidesRoot = mediaGallery.querySelector("slideshow-slides");
    if (!slidesRoot) return false;

    const slides = Array.from(slidesRoot.querySelectorAll(":scope > slideshow-slide"));
    if (!slides.length) return false;

    const template = slides[slides.length - 1].cloneNode(true);
    if (baseIndex == null) baseIndex = slides.length;

    items.slice(0, 5).forEach((raw, k) => {
      const item = sanitizeUrl(raw);
      if (!item) return;

      const isVideo = typeof item === "object" && item.type === "video";

      const slide = template.cloneNode(true);
      slide.setAttribute("data-morak-generic", "true");
      // El template puede venir de un slide nativo ya oculto (hideOtherNativeSlides corre antes),
      // así que hay que limpiar [hidden]/aria-hidden heredados o this.slides los filtraría.
      slide.removeAttribute("hidden");
      slide.setAttribute("aria-hidden", "true");
      slide.querySelectorAll("[data-media-id]").forEach((el) => el.removeAttribute("data-media-id"));

      const idx = baseIndex + k;
      slide.style.setProperty("view-timeline-name", `--slide-${idx}`);
      slide.querySelector(".product-media-container__zoom-button")?.remove();

      let videoEl = null;

      if (isVideo) {
        const container = slide.querySelector(".product-media-container") || slide;
        container.innerHTML = `
          <video
            src="${item.src}"
            muted
            loop
            playsinline
            webkit-playsinline="true"
            disablepictureinpicture
            preload="metadata"
            style="
              width: 100%;
              height: 100%;
              display: block;
              object-fit: cover;
              background: transparent;
            "
          ></video>`;
        videoEl = container.querySelector("video");
        if (videoEl) videoEl.muted = true;
      } else {
        setImgUrlDeep(slide, item);  // ← esto no lo tocas
      }

      slidesRoot.appendChild(slide);

      // preload="metadata" (no "auto") para no descargar el video completo en cada
      // carga de página — solo cuando el slide realmente se ve. Un <video> insertado
      // dinámicamente tampoco autorreproduce siempre solo con el atributo (Safari/iOS),
      // así que forzamos .play() nosotros al entrar en viewport.
      if (videoEl) {
        const io = new IntersectionObserver(
          (entries) => {
            if (entries.some((e) => e.isIntersecting)) {
              videoEl.play().catch(() => {});
              io.disconnect();
            }
          },
          { threshold: 0.25 }
        );
        io.observe(videoEl);
      }
    });

    // Actualiza timeline
    const slideshow = mediaGallery.querySelector("slideshow-component");
    if (slideshow) {
      const allSlides = Array.from(slidesRoot.querySelectorAll(":scope > slideshow-slide"));
      const names = allSlides.map((_, i) => `--slide-${i}`);
      slideshow.style.setProperty("--slideshow-timeline", names.join(", "));
    }

    return true;
  }

  function getActiveNativeMediaId(mediaGallery) {
    const activeSlide = mediaGallery.querySelector("slideshow-slide[aria-hidden='false']");
    const media = activeSlide?.querySelector("[data-media-id]");
    return media?.getAttribute("data-media-id") || null;
  }

  function hideOtherNativeSlides(mediaGallery, keepMediaId) {
    const slidesRoot = mediaGallery.querySelector("slideshow-slides");
    if (!slidesRoot) return;

    // Usamos el atributo [hidden] (no solo display:none) porque el componente nativo
    // (this.slides getter en slideshow.js) filtra por ese atributo para calcular índices
    // de navegación (select/jump). Si solo ocultamos con CSS, sus índices internos quedan
    // desincronizados de los nuestros en saltos >1 (ej. clicks de miniaturas).
    slidesRoot.querySelectorAll(":scope > slideshow-slide").forEach((slide) => {
      const isGeneric = slide.getAttribute("data-morak-generic") === "true";
      if (isGeneric) {
        slide.removeAttribute("hidden");
        slide.style.removeProperty("display");
        return;
      }

      // si no tenemos activo, no tocamos nada
      if (!keepMediaId) {
        slide.removeAttribute("hidden");
        slide.style.removeProperty("display");
        return;
      }

      const mediaId = slide.querySelector("[data-media-id]")?.getAttribute("data-media-id");
      if (mediaId && mediaId !== keepMediaId) {
        slide.setAttribute("hidden", "");
        slide.setAttribute("aria-hidden", "true");
      } else {
        slide.removeAttribute("hidden");
        slide.style.removeProperty("display");
      }
    });
  }

  // --- Controls (thumbnails / dots) ---

  // Cuenta de slides nativos que quedan visibles (no [hidden]) tras hideOtherNativeSlides.
  // Este es el índice base real que usa this.slides internamente para navegar.
  function getVisibleNativeSlideCount(mediaGallery) {
    const slidesRoot = mediaGallery.querySelector("slideshow-slides");
    if (!slidesRoot) return 0;
    return Array.from(
      slidesRoot.querySelectorAll(':scope > slideshow-slide:not([data-morak-generic="true"])')
    ).filter((s) => !s.hasAttribute("hidden")).length;
  }

  function getNativeSlides(mediaGallery) {
    const slidesRoot = mediaGallery.querySelector("slideshow-slides");
    if (!slidesRoot) return [];
    return Array.from(slidesRoot.querySelectorAll(":scope > slideshow-slide")).filter(
      (s) => s.getAttribute("data-morak-generic") !== "true"
    );
  }

  function getKeepNativeIndex(mediaGallery, keepMediaId) {
    if (!keepMediaId) return -1;
    const natives = getNativeSlides(mediaGallery);
    return natives.findIndex(
      (s) => s.querySelector("[data-media-id]")?.getAttribute("data-media-id") === keepMediaId
    );
  }

  function appendGenericThumbnails(mediaGallery, items, baseIndex) {
    mediaGallery.querySelectorAll(".slideshow-controls__thumbnails").forEach((container) => {
      const existing = Array.from(container.querySelectorAll(":scope > button.slideshow-controls__thumbnail"));
      if (!existing.length) return;

      const template = existing[existing.length - 1].cloneNode(true);

      items.slice(0, 5).forEach((raw, k) => {
        const item = sanitizeUrl(raw);
        if (!item) return;

        const isVideo = typeof item === "object" && item.type === "video";
        const idx = baseIndex + k;

        const btn = template.cloneNode(true);
        btn.setAttribute("data-morak-generic", "true");
        // No usamos on:click="/select/N" (select() nativo hace un "salto" reordenando
        // el DOM cuando el índice no es adyacente, lo cual se rompe con muchos slides
        // nativos [hidden] de por medio). Navegamos por scroll directo, igual que el
        // arrow-fix de más abajo.
        btn.removeAttribute("on:click");
        btn.setAttribute("data-morak-select-index", String(idx));
        btn.removeAttribute("aria-selected");
        btn.setAttribute("aria-label", `Ver imagen ${idx + 1}`);
        // El template puede venir de un botón nativo ya oculto (display:none) de un
        // ciclo anterior; hay que limpiar ese estilo heredado o el clon queda invisible.
        btn.style.removeProperty("display");
        btn.querySelector(".slideshow-controls__thumbnail-badge")?.remove();

        if (isVideo) {
          setImgUrlDeep(btn, VIDEO_THUMBNAIL_URL);
          const badge = document.createElement("span");
          badge.className = "slideshow-controls__thumbnail-badge";
          badge.textContent = "▶";
          btn.appendChild(badge);
        } else {
          setImgUrlDeep(btn, item);
        }

        container.appendChild(btn);
      });
    });
  }

  function appendGenericDots(mediaGallery, items, baseIndex) {
    mediaGallery.querySelectorAll(".slideshow-controls__dots").forEach((container) => {
      const existing = Array.from(container.querySelectorAll(":scope > li"));
      if (!existing.length) return;

      const template = existing[existing.length - 1].cloneNode(true);

      items.slice(0, 5).forEach((raw, k) => {
        const item = sanitizeUrl(raw);
        if (!item) return;

        const idx = baseIndex + k;
        const li = template.cloneNode(true);
        li.setAttribute("data-morak-generic", "true");
        // Igual que con las miniaturas: el template puede venir de un <li> nativo ya
        // oculto de un ciclo anterior.
        li.style.removeProperty("display");

        const btn = li.querySelector("button");
        if (btn) {
          btn.removeAttribute("on:click");
          btn.setAttribute("data-morak-select-index", String(idx));
          btn.removeAttribute("aria-selected");
          btn.style.setProperty("animation-timeline", `--slide-${idx}`);
          btn.textContent = String(idx + 1);
        }

        container.appendChild(li);
      });
    });
  }

  function hideOtherNativeThumbnails(mediaGallery, keepMediaId) {
    const keepIndex = getKeepNativeIndex(mediaGallery, keepMediaId);

    mediaGallery.querySelectorAll(".slideshow-controls__thumbnails").forEach((container) => {
      const natives = Array.from(
        container.querySelectorAll(':scope > button.slideshow-controls__thumbnail:not([data-morak-generic="true"])')
      );
      natives.forEach((btn, i) => {
        if (keepIndex === -1 || i === keepIndex) {
          btn.style.removeProperty("display");
        } else {
          btn.style.display = "none";
        }
      });
    });

    mediaGallery.querySelectorAll(".slideshow-controls__dots").forEach((container) => {
      const natives = Array.from(container.querySelectorAll(':scope > li:not([data-morak-generic="true"])'));
      natives.forEach((li, i) => {
        if (keepIndex === -1 || i === keepIndex) {
          li.style.removeProperty("display");
        } else {
          li.style.display = "none";
        }
      });
    });
  }

  // El on:click original de la miniatura/dot nativo que queda visible apunta a su
  // posición original entre TODOS los nativos (ej. /select/3). Pero this.slides ahora
  // la filtra como único nativo visible (índice 0). En vez de corregir el on:click
  // (que dispara el select() nativo, frágil con saltos no adyacentes), lo quitamos y
  // dejamos que el controls-click-fix navegue por scroll directo.
  function fixKeptNativeControlIndex(mediaGallery, keepMediaId) {
    const keepIndex = getKeepNativeIndex(mediaGallery, keepMediaId);
    if (keepIndex === -1) return;

    mediaGallery.querySelectorAll(".slideshow-controls__thumbnails").forEach((container) => {
      const natives = Array.from(
        container.querySelectorAll(':scope > button.slideshow-controls__thumbnail:not([data-morak-generic="true"])')
      );
      const btn = natives[keepIndex];
      if (!btn) return;
      btn.removeAttribute("on:click");
      btn.setAttribute("data-morak-select-index", "0");
    });

    mediaGallery.querySelectorAll(".slideshow-controls__dots").forEach((container) => {
      const natives = Array.from(container.querySelectorAll(':scope > li:not([data-morak-generic="true"])'));
      const btn = natives[keepIndex]?.querySelector("button");
      if (!btn) return;
      btn.removeAttribute("on:click");
      btn.setAttribute("data-morak-select-index", "0");
    });
  }

  function refreshSlideshowLayout(mediaGallery) {
    const slideshow = mediaGallery.querySelector("slideshow-component");
    if (!slideshow) return;

    requestAnimationFrame(() => {
      window.dispatchEvent(new Event("resize"));
      requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
    });
  }

  // El aria-selected nativo (this.current setter en slideshow.js) resalta por POSICIÓN
  // dentro de refs.thumbnails/dots SIN filtrar por [hidden], mientras que el índice de
  // slide (this.slides) SÍ está filtrado. Como ocultamos varios nativos, esos espacios
  // quedan desalineados. Escuchamos el evento nativo "slideshow:select" y corregimos
  // el resaltado usando solo los controles realmente visibles, en el mismo orden que
  // this.slides.
  function syncControlsSelection(mediaGallery, index) {
    if (index == null) return;

    mediaGallery.querySelectorAll(".slideshow-controls__thumbnails").forEach((container) => {
      const visible = Array.from(
        container.querySelectorAll(":scope > button.slideshow-controls__thumbnail")
      ).filter((b) => getComputedStyle(b).display !== "none");
      visible.forEach((b, i) => b.setAttribute("aria-selected", String(i === index)));
    });

    mediaGallery.querySelectorAll(".slideshow-controls__dots").forEach((container) => {
      const visible = Array.from(container.querySelectorAll(":scope > li")).filter(
        (li) => getComputedStyle(li).display !== "none"
      );
      visible.forEach((li, i) => li.querySelector("button")?.setAttribute("aria-selected", String(i === index)));
    });
  }

  function installSelectSync(mediaGallery) {
    if (!mediaGallery || mediaGallery.__morakSelectSyncInstalled) return;
    mediaGallery.__morakSelectSyncInstalled = true;

    mediaGallery.addEventListener("slideshow:select", (e) => {
      // Auto-corrección: algo (posiblemente el propio slideshow-component durante su
      // truco de reordenamiento para saltos >1) limpia el display:none de las
      // miniaturas/dots nativos ocultos. Lo reforzamos en cada evento de selección.
      hideOtherNativeThumbnails(mediaGallery, lastActiveNativeId);
      syncControlsSelection(mediaGallery, e.detail?.index);
    });
  }

  // Algo externo (probablemente un morph/re-render de la sección disparado por
  // actualizaciones de carrito u otro proceso del theme, no nuestro código) puede
  // eliminar los elementos genéricos inyectados sin pasar por nuestro run(). Si eso
  // pasa, lo detectamos y forzamos una reconstrucción completa.
  function installMorphGuard(mediaGallery) {
    if (!mediaGallery || mediaGallery.__morakMorphGuardInstalled) return;
    mediaGallery.__morakMorphGuardInstalled = true;

    const obs = new MutationObserver(() => {
      if (!lastAppliedKey) return;
      if (mediaGallery.querySelector('[data-morak-generic="true"]')) return;

      lastAppliedKey = null;
      scheduleRun("morph-guard");
    });

    obs.observe(mediaGallery, { childList: true, subtree: true });
  }

    // --- Arrow fix (force scroll-based navigation) ---
  function getSlidesRoot(mediaGallery) {
    return mediaGallery.querySelector("slideshow-slides");
  }

  function getSlideWidth(slidesRoot) {
    const slide = slidesRoot?.querySelector(":scope > slideshow-slide:not([hidden])");
    if (!slide) return 0;
    return slide.getBoundingClientRect().width || 0;
  }

  function getCurrentIndex(slidesRoot, slideW) {
    if (!slidesRoot || !slideW) return 0;
    return Math.round(slidesRoot.scrollLeft / slideW);
  }

  function scrollToIndex(slidesRoot, idx) {
    if (!slidesRoot) return;
    const slideW = getSlideWidth(slidesRoot);
    if (!slideW) return;
    slidesRoot.scrollTo({ left: idx * slideW, behavior: "smooth" });
  }

  function installArrowFix(mediaGallery) {
    if (!mediaGallery || mediaGallery.__morakArrowFixInstalled) return;
    mediaGallery.__morakArrowFixInstalled = true;

    // Captura clicks de flechas y fuerza scroll.
    mediaGallery.addEventListener(
      "click",
      (e) => {
        const btn = e.target?.closest?.("button.slideshow-control");
        if (!btn) return;

        // Solo dentro de este media-gallery
        if (!mediaGallery.contains(btn)) return;

        const slidesRoot = getSlidesRoot(mediaGallery);
        if (!slidesRoot) return;

        const slideW = getSlideWidth(slidesRoot);
        if (!slideW) return;

        // Prev/Next
        const isPrev = btn.classList.contains("slideshow-control--previous");
        const isNext = btn.classList.contains("slideshow-control--next");
        if (!isPrev && !isNext) return;

        // Si el theme tiene lógica interna “dañada”, la anulamos
        e.preventDefault();
        e.stopPropagation();

        const slides = Array.from(slidesRoot.querySelectorAll(":scope > slideshow-slide"))
          .filter((s) => !s.hasAttribute("hidden"));
        const max = Math.max(0, slides.length - 1);

        const cur = getCurrentIndex(slidesRoot, slideW);
        const next = Math.min(max, Math.max(0, cur + (isNext ? 1 : -1)));

        scrollToIndex(slidesRoot, next);
      },
      true // capture
    );
  }

  // Navegación para miniaturas/dots vía scroll directo (mismo enfoque que el
  // arrow-fix). Evita select()/on:click nativo, cuyo "salto" con reordenamiento de
  // DOM se rompe cuando hay muchos slides nativos [hidden] de por medio.
  function installControlsClickFix(mediaGallery) {
    if (!mediaGallery || mediaGallery.__morakControlsClickFixInstalled) return;
    mediaGallery.__morakControlsClickFixInstalled = true;

    mediaGallery.addEventListener(
      "click",
      (e) => {
        const btn = e.target?.closest?.("[data-morak-select-index]");
        if (!btn || !mediaGallery.contains(btn)) return;

        const idx = parseInt(btn.getAttribute("data-morak-select-index"), 10);
        if (Number.isNaN(idx)) return;

        e.preventDefault();
        e.stopPropagation();

        const slidesRoot = getSlidesRoot(mediaGallery);
        scrollToIndex(slidesRoot, idx);
        // No dependemos de que el scroll programático dispare "slideshow:select"
        // nativo (no siempre ocurre) — aplicamos el estado nosotros directamente.
        hideOtherNativeThumbnails(mediaGallery, lastActiveNativeId);
        syncControlsSelection(mediaGallery, idx);
      },
      true // capture
    );
  }

  // --- Scheduling ---
  let lastAppliedKey = null;
  let timer = null;

  function scheduleRun(reason = "") {
    clearTimeout(timer);
    timer = setTimeout(() => run(reason), DEBOUNCE_MS);
  }

  function runAfterRerender(reason) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scheduleRun(reason);
      });
    });
  }

  function findMediaGallery() {
    const scope = document.querySelector(".product-information") || document;
    return (
      scope.querySelector("media-gallery") ||
      document.querySelector("main media-gallery") ||
      document.querySelector("media-gallery")
    );
  }

  function run(reason = "") {
    const scope = document.querySelector(".product-information") || document;
    const mediaGallery = findMediaGallery();

    if (!mediaGallery) return;

    try {
      runInner(reason, scope, mediaGallery);
    } finally {
      revealThumbnails(mediaGallery);
    }
  }

  function runInner(reason, scope, mediaGallery) {
    const cfg = getConfig(mediaGallery);
    if (!cfg?.typeGalleries) return;

    const protLabel = getProtectionLabel(scope);
    const type = mapProtectionToTypeCode(protLabel);

    const urls = (cfg.typeGalleries?.[type] || []).map(sanitizeUrl).filter(Boolean);



    window.__MORAK_LAST_PICK = { reason, protLabel, type, count: urls.length };

    if (!type || !urls.length) return;

    const key = `${type}::${urls.join("|")}`;
    if (key === lastAppliedKey && mediaGallery.querySelector('[data-morak-generic="true"]')) return;

    removeGeneric(mediaGallery);

    // 1) Determinar y ocultar los slides nativos que no correspondan a la variante activa
    //    ANTES de agregar los genéricos, porque this.slides (usado por select()) filtra
    //    por [hidden] y necesitamos los índices finales correctos.
    const activeId = getActiveNativeMediaId(mediaGallery);
    lastActiveNativeId = activeId;
    hideOtherNativeSlides(mediaGallery, activeId);

    // 2) baseIndex = cantidad de slides nativos que quedan VISIBLES (normalmente 1)
    const baseIndex = getVisibleNativeSlideCount(mediaGallery);

    // 3) Agregar los genéricos usando ese índice base real
    const didSlides = appendGenericToSlideshow(mediaGallery, urls, baseIndex);
    appendGenericThumbnails(mediaGallery, urls, baseIndex);
    appendGenericDots(mediaGallery, urls, baseIndex);

    // 4) Corregir el on:click del nativo que quedó visible (su índice original ya no aplica)
    fixKeptNativeControlIndex(mediaGallery, activeId);

    // 5) Ocultar (cosmético) las miniaturas/dots de los nativos no activos
    hideOtherNativeThumbnails(mediaGallery, activeId);

    installArrowFix(mediaGallery);
    installControlsClickFix(mediaGallery);
    installSelectSync(mediaGallery);
    installMorphGuard(mediaGallery);

    // Reinicia la posición al slide 0 (el nativo activo) tras reconstruir la galería,
    // y esto dispara "slideshow:select" que corrige el resaltado de miniaturas/dots.
    const slideshow = mediaGallery.querySelector("slideshow-component");
    if (slideshow?.select) {
      slideshow.select(0, undefined, { animate: false });
    }
    syncControlsSelection(mediaGallery, 0);

    if (didSlides) refreshSlideshowLayout(mediaGallery);

    lastAppliedKey = key;
    window.__MORAK_LAST_APPLY = { didSlides, key };
  }

  // Detecta re-renders del theme (Shopify reemplaza media-gallery completo al cambiar
  // de variante) y re-aplica nuestra lógica. Acotado a .product-information (no toda
  // la página) para no reaccionar a mutaciones ajenas (carrito, otros widgets, etc).
  function installObserver() {
    const root = document.querySelector(".product-information") || document.documentElement;

    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        const added = Array.from(m.addedNodes || []);
        const match = added.find(
          (n) =>
            n.nodeType === 1 &&
            (n.matches?.("media-gallery") ||
              n.querySelector?.("media-gallery") ||
              n.matches?.("slideshow-slides") ||
              n.querySelector?.("slideshow-slides"))
        );

        if (match) {
          // Oculta la tira de miniaturas/dots del media-gallery recién insertado de
          // inmediato (sin esperar el debounce) para no mostrar el set nativo sin
          // filtrar mientras se reconstruye.
          const freshGallery = match.matches?.("media-gallery") ? match : match.querySelector?.("media-gallery");
          if (freshGallery) preHideThumbnails(freshGallery);

          runAfterRerender("mutation");
          break;
        }
      }
    });

    obs.observe(root, { childList: true, subtree: true });
  }

  function init() {
    scheduleRun("init");
    installObserver();

    // cambios de selects / radios
    document.addEventListener(
      "change",
      (e) => {
        const el = e.target;
        if (!(el instanceof Element)) return;
        if (el.closest("variant-picker") || el.closest("product-form") || el.closest(".product-information")) {
          // Si el cambio es específicamente de "Tipo de Case", ocultamos la tira de
          // miniaturas/dots al instante para evitar el flash de ver primero las
          // nativas y luego las complementarias.
          if (el.closest('[data-option-name="Tipo de Case"]')) {
            const mediaGallery = findMediaGallery();
            if (mediaGallery) preHideThumbnails(mediaGallery);
          }
          scheduleRun("change");
        }
      },
      true
    );

    document.addEventListener(
      "click",
      (e) => {
        const el = e.target;
        if (!(el instanceof Element)) return;
        // Ignora clicks en la paginación/flechas del propio slideshow (no son cambios de variante)
        if (
          el.closest("slideshow-controls") ||
          el.closest("slideshow-arrows") ||
          el.closest("[data-morak-generic]") ||
          el.closest("[data-morak-select-index]")
        ) {
          return;
        }
        if (el.closest("variant-picker") || el.closest("product-form") || el.closest(".product-information")) {
          scheduleRun("click");
        }
      },
      true
    );

    // eventos de variante (distintos themes/móvil)
    ["variantUpdate", "variant:change", "variantChange", "product:variant-change"].forEach((evt) => {
      document.addEventListener(
        evt,
        () => {
          runAfterRerender(evt);
        },
        true
      );
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
